import { render, staticRenderFns } from "./MobileMenu.vue?vue&type=template&id=667de071&"
import script from "./MobileMenu.vue?vue&type=script&lang=ts&"
export * from "./MobileMenu.vue?vue&type=script&lang=ts&"
import style0 from "./MobileMenu.vue?vue&type=style&index=0&id=667de071&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeaderLogo: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/page/header/PageHeaderLogo.vue').default,ProfileAvatar: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/profile/ProfileAvatar.vue').default})
